var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-screen max-h-screen overflow-y-hidden flex items-start m-0 relative"},[_c('router-view'),_c('QualityAssuranceModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }